import { Button, Icon, Layout, Spinner } from '@/components/generic';
import {
  useAssignReferralType,
  useGetUserData,
} from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

import ClaimRewards from './ClaimRewards';
import CommissionsTable from './CommissionsTable';
import ReferralCode from './ReferralCode';
import ReferralRulesPanel from './ReferralRulesPanel';
import WithdrawalsTable from './WithdrawalsTable';

export const Referral = () => {
  const { t } = useTranslation();
  const { userInfo } = useGetUserData();
  const { assignReferralType, isAssigning, error, success } =
    useAssignReferralType();

  const handleJoinProgram = async () => {
    // Default to referral type ID 1 (you can change this based on your requirements)
    await assignReferralType(
      Number(import.meta.env.VITE_REFERRAL_TYPE_ID) || 3
    );
  };

  return (
    <>
      {userInfo && (userInfo as any).referralTypeId ? (
        <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
          <Layout title={t('referral.title')}>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-3'>
              <div className='card m-0 p-6 h-full md:col-span-2 md:order-1 lg:col-span-1 lg:order-2 flex flex-col'>
                <div className='[&_p,&_ul]:mb-7 [&_ul]:list-disc [&_ul]:pl-5 [&_a]:underline [&_a]:hover:no-underline [&_p:last-child,&_ul:last-child]:mb-0 flex-1'>
                  <p className='mb-4!'>
                    <strong>{t('referral.referral_welcome_title')}</strong>
                  </p>

                  <p>
                    {t('referral.referral_welcome_message')}
                  </p>

                  <p>
                    {t('referral.referral_welcome_benefits')}
                  </p>

                  <p>
                    {t('referral.referral_welcome_cta')}
                  </p>
                </div>
              </div>

              <div className='h-full md:order-2 lg:order-1'>
                <ClaimRewards />
              </div>

              <div className='h-full md:order-3 lg:order-3'>
                <ReferralCode />
              </div>
            </div>

            <ReferralRulesPanel />

            <CommissionsTable />

            <WithdrawalsTable />
          </Layout>
        </div>
      ) : (
        <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
          <Layout title={t('referral.title')}>

            <div className='card m-0 p-8 mb-6'>
              <div className='max-w-3xl mx-auto'>
                <div className='[&_p,&_ul]:mb-6 [&_ul]:list-disc [&_ul]:pl-5 [&_a]:underline [&_a]:hover:no-underline [&_p:last-child]:mb-0 [&_ul:last-child]:mb-0'>
                  <p className='text-lg'>
                    <strong>{t('referral.referral_welcome_title')}</strong>
                  </p>

                  <p>
                    {t('referral.referral_welcome_message')}
                  </p>

                  <p>
                    {t('referral.referral_welcome_benefits')}
                  </p>

                  <p>
                    {t('referral.referral_welcome_cta')}
                  </p>
                </div>

                <div className='mt-8 flex flex-col items-center gap-4'>
                  <Button
                    onClick={handleJoinProgram}
                    disabled={isAssigning || success}
                    className='px-10 py-3 text-base'
                  >
                    {isAssigning ? (
                      <>
                        <Spinner className='w-4 h-4 mr-2 inline-block' />
                        {t('referral.joining')}
                      </>
                    ) : success ? (
                      <>
                        <Icon
                          className='w-4 h-4 fill-white mr-2 inline-block'
                          name='check'
                        />
                        {t('referral.successfully_joined')}
                      </>
                    ) : (
                      t('referral.join_referral_program')
                    )}
                  </Button>

                  {error && (
                    <div className='flex items-start gap-2 p-3 rounded-lg bg-red-500/10 border border-red-500/20 max-w-md'>
                      <Icon
                        className='w-4 h-4 fill-red-500 shrink-0 mt-0.5'
                        name='close'
                      />
                      <div className='text-caption text-red-500'>{error}</div>
                    </div>
                  )}

                  {success && (
                    <div className='flex items-start gap-2 p-3 rounded-lg bg-green-500/10 border border-green-500/20 max-w-md'>
                      <Icon
                        className='w-4 h-4 fill-green-500 shrink-0 mt-0.5'
                        name='check'
                      />
                      <div className='text-caption text-green-500'>
                        {t('referral.welcome_referral_program')}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </Layout>
        </div>
      )}
    </>
  );
};
